import React from 'react';
import { RhCheckbox } from '../../../../../../../dum';
import { IOrderProduction } from '../../order-production-form';
import { useFormContext } from 'react-hook-form';
import { useOrderProductionNamePrefix } from '../../order-production-name-prefix.context';
import { FIELD_LABELS, shortLabel } from '../../../../../../../../helpers';

const ARRAY_NAME: keyof IOrderProduction = 'order_production_employees';
const IS_LEADER_FIELD_NAME: keyof IOrderProduction['order_production_employees'][number] =
    'is_leader';

interface IInputProps {
    index: number;
}

export function OrderProductionIsLeaderInput({ index }: IInputProps) {
    const prefix = useOrderProductionNamePrefix();
    const PREFIXED_ARRAY = `${prefix}${ARRAY_NAME}`;
    const INPUT_NAME = `${PREFIXED_ARRAY}.${index}.${IS_LEADER_FIELD_NAME}`;
    const formContext = useFormContext();

    return (
        <RhCheckbox
            name={INPUT_NAME}
            label={shortLabel(FIELD_LABELS.is_leader)}
            disableGutters
            onChange={() => {
                const orderProductionEmployees = formContext.getValues(
                    PREFIXED_ARRAY,
                ) as IOrderProduction['order_production_employees'];
                orderProductionEmployees.forEach((e, i) => {
                    void formContext.trigger(
                        `${PREFIXED_ARRAY}.${i}.${IS_LEADER_FIELD_NAME}`,
                    );
                });
            }}
        />
    );
}
